import {DefaultResType, ErrorType} from "../../types/common/response";
import {baseApi} from "../../util/axiosConfig";
import {ProductInSearchParamType} from "../../pages/product/internal/list/interface";
import {ProductInDetailSearchParamType} from "../../pages/product/internal/detail/interface";

const url = "api/product/";

export async function readProductIn(param: ProductInSearchParamType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_product", param);
    } catch (err: any) {
        return err?.response;
    }
}

export async function uploadProductCurrencyExcelIn(data: FormData): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "upload_product_currency_excel", data, {headers: {"Content-Type": "multipart/form-data"}});
    } catch (err: any) {
        return err?.response;
    }
}

export async function exportProductExcelIn(param: ProductInSearchParamType): Promise<Blob | ArrayBuffer | Uint8Array | string | ErrorType> {
    const response = await baseApi.post(url + "export_product_excel", param, {
        responseType: "blob",
    });

    return response?.data;
}

export async function readProductDetailIn(data: ProductInDetailSearchParamType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_product_detail", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function updateProductDetailImageIn(data: FormData): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "update_image", data, {headers: {"Content-Type": "multipart/form-data"}});
    } catch (err: any) {
        return err?.response;
    }
}

export async function deleteProductDetailImageIn(data: {
    erpProductImageId: number,
    newErpProductid: string
}): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "delete_image", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function readProductGroupSelectBoxIn(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_product_group_select_box");
    } catch (err: any) {
        return err?.response;
    }
}

export async function updateProductGroupIn(data: {
    "outFlag": string,
    "productExplain": string,
    "new_erp_productid": string,
    "new_l_product_group@odata.bind": string
}): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "update_product_group", data);
    } catch (err: any) {
        return err?.response;
    }
}